var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.actions},[_c('img',{directives:[{name:"track",rawName:"v-track",value:({
      name: '收藏',
      id: '6793f7c0-4eb5-4a90-a970-85bd5835b812',
    }),expression:"{\n      name: '收藏',\n      id: '6793f7c0-4eb5-4a90-a970-85bd5835b812',\n    }"}],class:_vm._.icon,attrs:{"src":_vm.bookModel.isFavorite
        ? require('./images/已收藏.png')
        : require('./images/收藏.png')},on:{"click":_vm.handleFavoriteClick}}),_c('img',{directives:[{name:"track",rawName:"v-track",value:({
      name: '分享',
      id: '331a74e8-dda1-4cec-a379-a5fb92a6a6d4',
    }),expression:"{\n      name: '分享',\n      id: '331a74e8-dda1-4cec-a379-a5fb92a6a6d4',\n    }"}],class:_vm._.icon,attrs:{"src":require('./images/分享.png')},on:{"click":_vm.handleShareClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }